import React from "react";
import { useState, useEffect, useRef } from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import ScorecardFilters from "../App/ScorecardFilters";
import RetailerScorecardDetails from "../App/RetailerScorecardDetails";
import RetailerScorecardDetailsCharts from "../App/RetailerScorecardDetailsCharts";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";

function RetailerScorecard() {
  const [screenID, setScreenID] = useState(7);
  const [retailerScoreCardData, setRetailerScoreCardData] = useState([]);
  const [showLoadinganimation, setShowLoadinganimation] = useState(false);

  const [selectedId, setSelectedId] = useState({
    Dealers: 0,
    Facilities: 0,
    Years: 0,
    Months: 0,
    Brand: 0,
  });

  function ScorecardFiltersCallBack(p_selectedId: any) {
    selectedId.Dealers = p_selectedId.Dealers;
    selectedId.Facilities = p_selectedId.Facilities;
    selectedId.Years = p_selectedId.Years;
    selectedId.Months = p_selectedId.Months;
    selectedId.Brand = p_selectedId.Brand;
    setSelectedId(selectedId);
    getReportFactorKeysData();
  }

  function getReportFactorKeysData() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.dealerid = selectedId.Dealers;
    object.facilityid = selectedId.Facilities;
    object.year = selectedId.Years;
    object.month = selectedId.Months;
    object.brandid = selectedId.Brand;
    setShowLoadinganimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/PFIRSFactorKey/GetReportFactorKeysData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setRetailerScoreCardData(l_response);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
        setShowLoadinganimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  return (
    <div className="page--contents">
      {showLoadinganimation && <LoadingAnimation />}
      <div className="page--breadcrumb">
        <a>Retailer Scorecard</a>
      </div>
      <div className="page--data">
        <div className="flex-container">
          <div className="flex-items">
            <ScorecardFilters
              ScreenID={screenID}
              ScorecardFiltersCallBack={ScorecardFiltersCallBack}
            />
          </div>
        </div>
        {retailerScoreCardData && retailerScoreCardData.length > 0 && (
          <div className="section-table retail-section">
            <RetailerScorecardDetailsCharts
              retailerScoreCardData={retailerScoreCardData}
            />
            <div className="flex-details">
              <RetailerScorecardDetails
                TypeId={200}
                retailerScoreCardData={retailerScoreCardData[0]}
              />
              <RetailerScorecardDetails
                TypeId={300}
                retailerScoreCardData={retailerScoreCardData[1]}
              />
              <RetailerScorecardDetails
                TypeId={400}
                retailerScoreCardData={retailerScoreCardData[2]}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default RetailerScorecard;
